import { Crud, HttpClient, httpClient, HttpClientResponse } from 'lib/HttpClient';

export interface IShopifyReconcileResult {
    created: Array<{ topic: string; callbackUrl: string }>;
    updated: Array<{ id: string; topic: string; callbackUrl: string }>;
    deleted: Array<{ id: string; topic: string }>;
}

class ShopifyApi extends Crud {
    constructor(client: HttpClient) {
        super(client, import.meta.env.API_SERVER_URL, 'shopify');
    }
    refreshWebhooks(locationId: string): HttpClientResponse<IShopifyReconcileResult> {
        return this.httpClient.post(`${this.api}/shopify/refreshWebhooks/${locationId}`);
    }
}

export const shopifyApi = new ShopifyApi(httpClient);
